
    import { Vue,Component,Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import VueQrcode from '@xkeshi/vue-qrcode'
    const common = namespace('common')
    const site = namespace('site')
    @Component({
        components: {
            VueQrcode
        }
    })
    export default class Home extends Vue{
        dialogVisible:boolean = false
        radio7:any = ''
        submitting:boolean = false
        num8:number = 0
        code_url:string = ''
        @common.State('prepaid') prepaid:any
        @common.State('payment') payment:any
        @site.State('info') info:any
        @common.Action('getPrepaid') getPrepaid:any
        @common.Action('smsRecharge') smsRecharge:any
        @common.Action('alipaySmsRecharge') alipaySmsRecharge:any
        
        async created(){
            await this.getPrepaid()
        }
        paymentFun(){
            if(this.radio7 == "") return this.$message.error("请选择套餐")
            this.submitting = true
            if(this.info.com_area == 'hz'){// /common/alipay/precreate
                if(this.radio7  == '6' ){
                    this.alipaySmsRecharge({
                        body:"自定义信息费充值",
                        type:0,
                        product_id:"5a9506f35c2bfb2ac3b465dd",
                        fee:this.num8 * 100,
                        present:0
                    })
                    return
                }
                this.alipaySmsRecharge({
                    body:this.radio7.content,
                    type:0,
                    product_id:this.radio7._id,
                    fee:this.radio7.fee,
                    present:this.radio7.present
                })
            }else{
                if(this.radio7  == '6' ){
                    this.smsRecharge({
                        body:"自定义信息费充值",
                        type:0,
                        product_id:"5a9506f35c2bfb2ac3b465dd",
                        fee:this.num8 * 100,
                        present:0
                    })
                    return
                }
                this.smsRecharge({
                    body:this.radio7.content,
                    type:0,
                    product_id:this.radio7._id,
                    fee:this.radio7.fee,
                    present:this.radio7.present
                })
            }
        }
        @Watch('payment')
        paymentChange(val:any,oldVal:string){
            this.submitting = false
            this.dialogVisible = true
            this.code_url = val.code_url
        }
    }
